<template>
  <a-card :bordered='false'>
    <AppraiseSignatureButton
      v-show="needSign & !stampShowed"
      ref="SignatureButton"
      :pdf-params="pdfParams"
      :stampShowed="stampShowed"
      :disabled="!needSign"
      @sign="sign"
      @signShow="signShow"
    ></AppraiseSignatureButton>
    <AppraiseSignFileShow v-show="signedPdfFlag && !stampShowed" @signedPdfIsExist='signedPdfIsExist' :sectionId='workflowInstanceId' :type='pdfParams.type' style="margin-top:10px"></AppraiseSignFileShow>

    <div v-show='!stampShowed && !signedPdfFlag' id="pdfCentent" >
      <div style="font-weight: bold;font-size: 24px;text-align: center">{{currentTabName}}</div>
      <a-table :columns="columns" :data-source="candidates" :pagination="false">
      </a-table>
      <ExpertStampTable :bidProjectId="bidProjectId" :sectionId="sectionId"></ExpertStampTable>
    </div>

    <AppraiseSignatureComponent
      v-show="stampShowed"
      ref="stamp"
      :pdf-params="pdfParams"
      @checkStampForm="checkStampForm"
      @changeIsStamp="changeIsStamp"
    ></AppraiseSignatureComponent>
  </a-card>
</template>

<script>

import { getAction } from '@/api/manage'
import AppraiseSignatureComponent from '@comp/AppraiseSignatureComponent'
import AppraiseSignatureButton from '@comp/AppraiseSignatureButton'
import ExpertStampTable from '@/components/ExpertStampTable'
import AppraiseSignFileShow from "@views/bobidappraise/modules/AppraiseSignFileShow.vue";

export default {
  name: 'ProtocolCandidateWaterLowResult',
  components: {
    AppraiseSignatureComponent,AppraiseSignatureButton,ExpertStampTable,AppraiseSignFileShow
  },
  data() {
    return {
      candidates: [],
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '企业名称',
          dataIndex: 'bidderName',
          width: 250,
          customRender: function(t, r, index) {
            if (r.unionEnterpriseName){
              return t+"(联合体成员：" + r.unionEnterpriseName + ")"
            }else{
              return t
            }
          }
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'bidderOrgCode',
        },
        {
          title: '投标报价',
          dataIndex: 'bidPrice',
        },
        // {
        //   title: '信用评分',
        //   width: 100,
        //   dataIndex: 'bidderCreditScore'
        // },
      ],
      can: {},
      //以下签章-----------
      needSign: true,
      isStamp: true,
      stampShowed:false,
      pdfParams: {
        isEditorCuring: "1",
        pageId:"",
        signedPdfUrl: "",
        bidProjectId: '',
        sectionId: '',
        type: 'protocolCandidateResult',
        typeZh: '拟推荐候选人签章',
        htmlTitle: '拟推荐候选人签章',
        fp : '2',
        saveTmFileFlag:'1',
        signType:'1'
      },
      signDisabled:false,
      signedPdfFlag:true,
    }
  },
  props: ['instStepId','workflowInstanceId','sectionId', 'bidProjectId','currentTabName'],
  created() {
    this.pdfParams.bidProjectId = this.bidProjectId
    this.pdfParams.sectionId = this.workflowInstanceId
    this.getCandidateInfo();
    this.pdfParams.type = this.pdfParams.type + "-" + this.workflowInstanceId;
  },
  methods: {
    getCandidateInfo() {
      getAction('/ebid-ce/boCandidate/water/getBoCandidatelow/' + this.sectionId + "/" + this.workflowInstanceId + "/" + this.instStepId , {}).then(res => {
        if (res.success) {
          this.candidates = res.result;
          let candidate = this.candidates[0];
          if(candidate.candidateScoreInfoDTOS != null) {
            for (let i = 0; i < candidate.candidateScoreInfoDTOS.length; i++) {
              let model = {};
              model.title = candidate.candidateScoreInfoDTOS[i].name + "得分"
              model.dataIndex = "score" + i;
              this.columns.push(model)
            }

            for(let i = 0; i<this.candidates.length; i++) {
              for(let j = 0; j<this.candidates[i].candidateScoreInfoDTOS.length; j++) {
                this.candidates[i]["score" + j] = this.candidates[i].candidateScoreInfoDTOS[j].evalScore;
              }
            }
          }
          let model = {};
          model.title = "是否否决投标"
          model.dataIndex = "isPass"
          this.columns.push(model);
          for(let i = 0; i<this.candidates.length; i++) {
            if (this.candidates[i].isPass == null){
              this.candidates[i].isPass = "否"
            }else{
              this.candidates[i].isPass = "是"
            }
          }

          let reasonModel = {};
          reasonModel.title = "否决投标原因"
          reasonModel.dataIndex = "disuseReason"
          reasonModel.width = '250px'
          this.columns.push(reasonModel);
        }
      })
    },
    sign(type) {
      this.pdfParams.signType = type;
      //显示签章
      var that = this;
      this.$confirm({
        title: '提示',
        content: '您确定要进行签章操作吗？',
        onOk() {
          //设置本页面标识，用于redis key记录当前页面签章信息
          that.pdfParams.pageId = that.instStepId + "_" + "report" + "_" + new Date().getTime();
          that.$refs.stamp.checkStamp();
        },
        onCancel(){
          that.pdfParams.pageId="";
          that.pdfParams.signedPdfUrl="";
          that.stampShowed = false;
          that.$refs.stamp.pdfUrl=null;
        },
      })
    },
    changeIsStamp(val) {
      this.stampShowed = val;
    },
    checkStampForm(callback) {
      callback(true);
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId,this.pdfParams.type);
    },
    //判断签章文件是否存在
    signedPdfIsExist(value){
      this.signedPdfFlag = value
    },
  }
}
</script>

<style scoped>

</style>